import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

/**
 * The point-of-sale surface: public, chromeless, inside the ordinary app tree.
 *
 * Copied from `CgvPageConfig` — the shipping precedent for a route that is both. `auth: null`
 * must be explicit: `routeConfigs` is generated with `authRoles.owner` as the default, and an
 * omitted key inherits it, which would bounce every till to the login page. Chrome is hidden
 * through `settings.layout.config` rather than a `useRouteMatch` check in the toolbar, which
 * is how `/scanner` ended up still rendering a navbar it did not want.
 */
const PosPageConfig = {
  settings: {
    layout: {
      config: {
        scroll: 'content',
        navbar: { display: false },
        toolbar: { display: false },
        footer: { display: false },
        leftSidePanel: { display: false },
        rightSidePanel: { display: false },
        mode: 'fullwidth',
      },
    },
    customScrollbars: false,
  },
  routes: [
    {
      auth: null,
      path: routesUrl.posLadditionSearch,
      exact: true,
      component: React.lazy(() => import('./pages/LadditionSearchPage')),
    },
    {
      auth: null,
      path: routesUrl.posLadditionOffers,
      exact: true,
      component: React.lazy(() => import('./pages/LadditionOffersPage')),
    },
    {
      auth: null,
      path: routesUrl.posTill,
      exact: true,
      component: React.lazy(() => import('./pages/PosTillPage')),
    },
    {
      auth: null,
      path: routesUrl.posTillEntry,
      exact: true,
      component: React.lazy(() => import('./pages/PosTagEntryPage')),
    },
  ],
};

export default PosPageConfig;
